import React from "react";
import { FaVideo } from "react-icons/fa";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";

const CompanyVideo = ({ companyVideos }) => {
  return (
    <section className="my-5">
      <h2 className="fs-26 gilroy-bold my-5 pt-5">Company Video Library</h2>
      <div className="row g-5">
        {companyVideos?.map((video, index) => (
          <div key={index} className="col-12 col-sm-6 col-md-4">
            <a href={video?.link} className="text-decoration-none text-dark">
              <img
                src={`${IMAGE_BASE_URL}/${video?.image}`}
                alt=""
                className=" d-block img-fluid"
                style={{
                  height: "200px",
                  width: "100%",
                  objectFit: "cover",
                }}
              />
              <h3 className="fs-20 mt-4 gilroy-bold">{video?.title}</h3>
              <a
                href={`${BASE_URL}/media-library-video-downolad/${video?.id}`}
                download
                className="text-decoration-none fs-14 gilroy-bold text-orange-ryb mt-2 d-block"
              >
                <FaVideo className="text-success" /> Video high resolution
              </a>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CompanyVideo;
